import React, { useEffect, useState } from "react";
import "./profileSection.scss";
import { connect } from "react-redux";
import { updateUserData, updateUser } from "../../redux/action/user";
import TextBox from "../../atoms/textbox";
import { FormGroup, MenuItem, Modal, Select, Typography } from "@mui/material";
import TextboxWithDropdown from "../../atoms/textboxWithDropdown";
import ToggleButtonGroupBox from "../../atoms/toggleButtonGroupBox";
import ButtonInput from "../../atoms/button";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import undraw_well_done from "../../assets/images/undraw_well_done.png";
import SnackBar from "../../atoms/snackBar";
import { isSubscriptionActive } from "../../common";

const heightOption = [
  {
    value: "Cm",
    text: "Cm",
  },
  {
    value: "Inches",
    text: "Feet",
  },
];

const weightOption = [
  {
    value: "Kg",
    text: "Kg",
  },
  {
    value: "Pounds",
    text: "Lbs",
  },
];

// For Age Radio Button
// const ageOption = [
//     {
//         value: 'below18',
//         text: 'Below 18',
//     },
//     {
//         value: '18-25',
//         text: '18-25',
//     },
//     {
//         value: '25-50',
//         text: '25-50',
//     },
//     {
//         value: '50-75',
//         text: '50-75',
//     },
//     {
//         value: 'above75',
//         text: 'Above 75',
//     }
// ]

const ageDropDown = [
  {
    value: "-1",
    text: "Select Age",
  },
  {
    value: "18-24",
    text: "18-24",
  },
  {
    value: "25-34",
    text: "25-34",
  },
  {
    value: "35-44",
    text: "35-44",
  },
  {
    value: "45-54",
    text: "45-54",
  },
  {
    value: "55-64",
    text: "55-64",
  },
  {
    value: "65 and Over",
    text: "65 and Over",
  },
];

const genderOption = [
  {
    value: "Male",
    text: "Male",
  },
  {
    value: "Female",
    text: "Female",
  },
  {
    value: "Other",
    text: "Other",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400px",
  bgcolor: "#fff",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

const ProfileSection = (props) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [recomdation, setRecomdation] = useState(false);

  const isSubscription = isSubscriptionActive(props?.user)

  const zipCodeChange = (value) => {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(value) === false) {
      if (value.length < 6) {
        props.updateUserData({
          ...props.user,
          zipCode: value,
        });
      }
    }
  };

  useEffect(() => {
    if (props.user?.profileError) {
      setErrorMessage(props.user?.profileError);
    }
  }, [props.user?.profileError]);

  useEffect(() => {
    if (errorMessage) {
      setOpenSnackBar(true);
    }
  }, [errorMessage]);

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
    setErrorMessage("");
  };

  useEffect(() => {
    if (
      localStorage.getItem("progressDone") !== null &&
      localStorage.getItem("detailDone") !== null
    ) {
      navigate("/result");
    }
  }, []);

  const saveUserData = () => {
    // ─── Height Validation ─────────────────────────────────────────
    if (props.user.heightunit === "Inches") {
      const [feet = 0, inches = 0] = props.user.height
        ? props.user.height.toString().split(".").map(Number)
        : [];

      // If the height is empty or non-numeric
      if (isNaN(feet) || isNaN(inches) || feet < 0 || inches < 0) {
        setErrorMessage("Enter valid height in feet.inches format");
        return;
      }

      const totalInches = feet * 12 + inches;
      if (totalInches < 21.5) {
        setErrorMessage("Minimum height must be at least 21.5 inches (~55 cm)");
        return;
      }
    } else if (props.user.heightunit === "Cm") {
      const cm = parseFloat(props.user.height);

      // Check if the height is empty or non-numeric
      if (isNaN(cm) || cm < 54.6) {
        setErrorMessage("Minimum height must be at least 54.6 cm (~21.5 inches)");
        return;
      }
    }

    // ─── Weight Validation (kg ↔ lbs) ───────────────────────────────
    if (!props.user.weight || parseFloat(props.user.weight) <= 0) {
      setErrorMessage("Weight is required");
      return;
    }

    // Weight Validation based on units (kg ↔ lbs)
    if (props.user.weightunit === "Pounds" && parseFloat(props.user.weight) < 37) {
      setErrorMessage("Minimum weight must be at least 37 lbs (~17 kg)");
      return;
    } else if (props.user.weightunit === "Kg" && parseFloat(props.user.weight) < 17) {
      setErrorMessage("Minimum weight must be at least 17 kg (~37 lbs)");
      return;
    }

    // ─── Zip Code Validation ────────────────────────────────────────
    if (!props.user.zipCode || props.user.zipCode.length < 5 || /^0+$/.test(props.user.zipCode)) {
      setErrorMessage("Valid Zip Code is required");
      return;
    }

    // ─── Age Validation ─────────────────────────────────────────────
    if (!props.user.age) {
      setErrorMessage("Age is required");
      return;
    }

    // ─── Gender Validation ──────────────────────────────────────────
    if (!props.user.gender) {
      setErrorMessage("Gender is required");
      return;
    }

    // ─── All validations passed ─────────────────────────────────────
    let tempObject = {
      height: props.user.height,
      heightunit: props.user.heightunit,
      weight: props.user.weight,
      weightunit: props.user.weightunit,
      zipcode: props.user.zipCode,
      age: props.user.age,
      gender: props.user.gender,
      id: props.user._id,
    };

    props.updateUser(tempObject, openRecomdation);
  };



  const openRecomdation = () => {
    if (isSubscription) {
      // setRecomdation(true);
      setRecomdation(false);
      localStorage.setItem("detailDone", true);
      navigate("/result");
    }
    else {
      openModal();
    }
  };

  const openModal = () => {
    // setOpen(!open);
    setRecomdation(false);
    localStorage.setItem("detailDone", true);
    navigate("/result");
  };

  const gotoProgressPage = () => {
    localStorage.setItem("detailDone", true);
    setRecomdation(true);
    navigate("/result");
  };

  const heightValueChange = (value) => {
    if (value === '' || /^\d{0,3}(\.\d{0,2})?$/.test(value)) {
      if (value <= 300) {
        props.updateUserData({
          ...props.user,
          height: value,
        });
      }
    }
  };

  const setHeightFeet = (value) => {
    if (value === '' || /^\d{0,2}$/.test(value)) {
      if (value.indexOf(".") === -1) {
        if (value <= 10) {
          let tempHeightValue = props.user.height
            ? props.user.height.split(".")
            : "";
          let tempValue = "";
          if (tempHeightValue.length > 0) {
            tempValue = value + "." + tempHeightValue[1];
          } else {
            tempValue = value + "";
          }
          props.updateUserData({
            ...props.user,
            height: tempValue,
          });
        }
      }
    }

  };

  const setHeightInch = (value) => {
    if (value === '' || /^\d{0,2}$/.test(value)) {
      if (value.indexOf(".") === -1) {
        if (value <= 11) {
          let tempHeightValue = props.user.height
            ? props.user.height.split(".")
            : "";
          let tempValue = "";
          if (tempHeightValue.length > 0) {
            tempValue = tempHeightValue[0] + "." + value;
          } else {
            tempValue = "0." + value;
          }
          props.updateUserData({
            ...props.user,
            height: tempValue,
          });
        }
      }
    }
  };

  const heightDropDownChange = (value) => {
    props.updateUserData({
      ...props.user,
      heightunit: value,
      height: "",
    });
  };

  const weightValueChange = (value) => {
    const maxWeight = props.user.weightunit === "Kg" ? 300 : 660;
    const numericValue = parseFloat(value);
    if (value === '' || /^\d{0,3}(\.\d{0,2})?$/.test(value)) {
      if (value !== '' && numericValue <= maxWeight) {
        props.updateUserData({
          ...props.user,
          weight: value,
        });
      } else if (value === '') {
        props.updateUserData({
          ...props.user,
          weight: '',
        });
      }
    }
  };


  const weightDropDownChange = (value) => {
    props.updateUserData({
      ...props.user,
      weightunit: value,
      weight: '',
    });
  };

  const ageValueChange = (value) => {
    if (value !== "-1") {
      props.updateUserData({
        ...props.user,
        age: value,
      });
    }
  };

  const genderValueChage = (value) => {
    props.updateUserData({
      ...props.user,
      gender: value,
    });
  };

  const isNumberKey = (event) => {
    const allowedKeys = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Enter",
    ];

    if ((event.key >= "0" && event.key <= "9") || allowedKeys.includes(event.key)) {
      return true;
    }
    event.preventDefault();
    return false;
  };
  const preventInvalidKeys = (e) => {
    const invalidKeys = ["e", "E", "+", "-"];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
    }
  };


  return (
    <div className="profile-section">
      {/* <CenterLoading open={props.user.isLoading} /> */}
      <div className="row">
        <h2 className="title yellow-font center-text">
          {props.user.language?.profileDetail?.title}
        </h2>
        <p
          className="subTitle white-color center-text avenir-bold"
          style={{ marginLeft: "50px", marginRight: "50px" }}
        >
          {props.user.language?.profileDetail?.subTitle}
        </p>
      </div>
      <FormGroup>
        {props.user.heightunit === "Inches" ? (
          <div className="inches-boxes">
            <TextboxWithDropdown
              type="number"
              placeholder={
                props.user.language?.profileDetail?.heightField?.placeHolder +
                " in feet"
              }
              value={
                props.user.height &&
                  props.user.height.split(".").length > 0 &&
                  props.user.height.split(".")[0]
                  ? props.user.height.split(".")[0]
                  : ""
              }
              valueChange={setHeightFeet}
              onKeyDown={isNumberKey}
              option={heightOption}

              dropDownDefaultValue={props.user.heightunit}
              selectChange={heightDropDownChange}
            />
            <TextboxWithDropdown
              type="number"
              placeholder={
                props.user.language?.profileDetail?.heightField?.placeHolder +
                " in inches"
              }
              value={
                props.user.height &&
                  props.user.height.split(".").length > 0 &&
                  props.user.height.split(".")[1]
                  ? props.user.height.split(".")[1] <= 12
                    ? props.user.height.split(".")[1]
                    : props.user.height.split(".")[1].slice(0, -1)
                  : ""
              }
              valueChange={setHeightInch}
              isLabel={true}
              labelText={"Inches"}
              onKeyDown={isNumberKey}
              option={heightOption}
            />
          </div>
        ) : (
          <TextboxWithDropdown
            type="number"
            placeholder={
              props.user.language?.profileDetail?.heightField?.placeHolder
            }
            value={props.user.height}
            valueChange={heightValueChange}
            dropDownDefaultValue={props.user.heightunit}
            selectChange={heightDropDownChange}
            option={heightOption}
            onKeyDown={preventInvalidKeys}
          />
        )}

        <TextboxWithDropdown
          type="number"
          placeholder={
            props.user.language?.profileDetail?.weightField?.placeHolder
          }
          value={props.user.weight}
          valueChange={weightValueChange}
          dropDownDefaultValue={props.user.weightunit}
          selectChange={weightDropDownChange}
          option={weightOption}
          onKeyDown={preventInvalidKeys}
        />

        <TextBox
          placeholder={
            props.user.language?.profileDetail?.zipCodeField?.placeHolder
          }
          type="number"
          value={props.user.zipCode}
          onKeyDown={isNumberKey}
          valueChange={zipCodeChange}
        />

        <Select
          sx={{
            color: "white",
            "& fieldset": {
              border: "none",
            },
            "& .MuiSvgIcon-root": {
              color: "white",
            },
          }}
          className={`age-drop-down`}
          variant="outlined"
          defaultValue={props.user.age ? props.user.age : -1}
          value={props.user.age ? props.user.age : -1}
          onChange={(e) => ageValueChange(e.target.value)}
          placeholder="Select age"
        >
          {ageDropDown.map((obj, index) => {
            return (
              <MenuItem
                key={index}
                value={obj.value}
                sx={{
                  justifyContent: "center",
                  backgroundColor:
                    obj.value === props.user.age ? "#0BD7EE !important" : "transparent",
                }}
              >
                {obj.text}
              </MenuItem>
            );
          })}
        </Select>
        <div className="bottom-button-group margin-top-10">
          <ToggleButtonGroupBox
            option={genderOption}
            value={props.user.gender}
            valueChange={genderValueChage}
          />
          <ButtonInput
            text={"Get my score"}
            class="next-button"
            onSubmit={saveUserData}
            style={{ height: "54px", width: "162px" }}
          />
        </div>
      </FormGroup>
      <Modal open={open} onClose={openModal} className="success-modal">
        <Box sx={style} className="success-modal">
          <Typography variant="h6" component="h2" className="center-text">
            <img
              src={undraw_well_done}
              alt=""
              width={"224px"}
              height={"202px"}
            />
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            className="center-text modal-title-text "
          >
            <b className="margin-top-20 avenir-bold">
              {props.user.language?.profileDetail?.successModal?.title}
            </b>
          </Typography>
          <Typography sx={{ mt: 2 }}>
            <p className="modalDetail benton-sans-font">
              {props.user.language?.profileDetail?.successModal?.description}
            </p>
          </Typography>
          <ButtonInput
            class="modal-button"
            text={props.user.language?.profileDetail?.successModal?.buttonText}
            onSubmit={gotoProgressPage}
          />
        </Box>
      </Modal>
      <SnackBar
        open={openSnackBar}
        message={errorMessage}
        handleCloseSnackBar={handleCloseSnackBar}
      />
    </div>
  );
};

ProfileSection.propTypes = {};
ProfileSection.defaultProps = {};

const actionCreators = {
  updateUserData,
  updateUser,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(ProfileSection);
